import { useQuery } from '@tanstack/react-query';

import type { LvaGlTieoutResponse } from '@dcc-erp/shared';

import { api } from '../api';

// ============================================================
// LVA Phase D — memo-vs-GL tie-out report. Mirrors lib/queries/lva.ts
// (api() + companyId-scoped cache keys + URLSearchParams filter building) and
// the useLvaItems filter shape. Read-only: the server endpoint reconciles each
// register item's cost against the linked JV's LVA-expense debit and returns
// rows + a summary — no mutation, so there is nothing to invalidate.
// ============================================================

export interface LvaGlTieoutFilters {
  period?: string;
  branchId?: string;
  departmentId?: string;
}

export function useLvaGlTieout(companyId: string | undefined, filters: LvaGlTieoutFilters = {}) {
  const qs = new URLSearchParams();
  if (filters.period) qs.set('period', filters.period);
  if (filters.branchId) qs.set('branchId', filters.branchId);
  if (filters.departmentId) qs.set('departmentId', filters.departmentId);
  const search = qs.toString();
  return useQuery({
    queryKey: ['lva-gl-tieout', companyId, filters] as const,
    queryFn: () =>
      api<LvaGlTieoutResponse>(
        `/companies/${companyId}/lva-items/gl-tieout${search ? `?${search}` : ''}`,
      ),
    enabled: !!companyId,
  });
}
